//import { inject } from "vue";
//全局参数文件
import config from "../../config/config";
// 公共处理函数
import uCommon from "./uCommon";
// 路由函数
import uRouter from "./uRouter";
// 全局方法
import uGlobal from "./uGlobal";
// 全局vuex
import uStore from "./uStore";

const $uroadUtils = function () {
  let $uRouter = uRouter();
  let $uCommon = uCommon;
  let $uConfig = config;
  let $uGlobal = uGlobal;
  let $uStore = uStore;

  return {
    $uRouter,
    $uCommon,
    $uConfig,
    $uGlobal,
    $uStore,
  };
};
const uUtils = {
  install(Vue) {
    Vue.provide("$uroadUtils", $uroadUtils);
  },
  uroadUtils: $uroadUtils,
};
export default uUtils;
